export const RELIGION_MODEL = "religion";

const religionModel = {
  name: ""
};

export default religionModel;
